export const STANDALONE_ROUTES = ['/coinbase', '/email', '/oauth-callback', '/social'];
